import type { FC } from "preact/compat";
import { RouterProvider } from "react-router-dom";
import { AppProvider, store } from "./store";
import router from "./router";

const App: FC = () => (
    <AppProvider value={store}>
        <RouterProvider router={router} />
    </AppProvider>
);

export default App;
